import { useState, useCallback } from 'react';

const STORAGE_KEY = "plan";

const usePlanList = () => {
    const [plans, setPlans] = useState([]);

    const load = useCallback(() => {
        let list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        setPlans(list);
        return list;
    }, []);

    const addPlan = useCallback((plan) => {
        setPlans(prev => {
            let next = [...prev, plan];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }, []);

    const updatePlan = useCallback((idx, plan) => {
        setPlans(prev => {
            let next = [...prev];
            next[idx] = plan;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }, []);

    const removePlan = useCallback((idx) => {
        setPlans(prev => {
            let next = [...prev];
            next.splice(idx, 1);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }, []);

    return { plans, setPlans, load, addPlan, updatePlan, removePlan };
};

export default usePlanList;
